import React, { useEffect, useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Box, Container, Paper, Alert, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import globalContext from '../../context/context';

const ActivatePage = () => {
  const { t } = useTranslation();
  const { activate, resetActivate, contextData: { activationSuccess, activationFailure } } = useContext(globalContext);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const key = searchParams.get('key');

    if (key) {
      activate(key);
    }

    return () => {
      resetActivate();
    };
  }, []);

  return (
    <Box sx={{ bgcolor: 'rgba(0,0,0, .2)', minHeight: '100vh', py: 4 }}>
      <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex' }}>
        <Paper sx={{ width: { xs: '95%', md: '60%' }, p: 3, bgcolor: '#fff' }}>
          <Typography variant="h4" component="h1" sx={{ textAlign: 'center', pb: 3 }}>
            {t('ActivatePage.title')}
          </Typography>
          {activationSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              <strong>{t('ActivatePage.success')}</strong>{' '}
              <Link to="/login" style={{ color: 'inherit', textDecoration: 'underline' }}>
                {t('ActivatePage.successLink')}
              </Link>
              .
            </Alert>
          )}
          {activationFailure && (
            <Alert severity="error" sx={{ mb: 2 }}>
              <strong>{t('ActivatePage.error')}</strong>
            </Alert>
          )}
        </Paper>
      </Container>
    </Box>
  );
};

export default ActivatePage;